import * as Yup from "yup";

// Error logic objects
const companyName = {
	regex: /^[^\\]+$/,
	requiredMessage: "Company name is required with a custom logo",
	errorMessage: "Company name cannot include a backslash",
};

const clientLogo = {
	regex: /\.(png|jpg|jpeg)$/i,
	errorMessage: "Please upload a logo in JPG or PNG format",
};
const webdemoValidationSchema = {
	companyName: Yup.string().when("clientLogo", {
		is: value => value && value.length > 0 && /\.(png|jpg|jpeg)$/i.test(value),
		then: Yup.string()
			.required(companyName.requiredMessage)
			.matches(companyName.regex, {
				message: companyName.errorMessage,
				excludeEmptyString: true,
			}),
		otherwise: Yup.string().matches(companyName.regex, {
			message: companyName.errorMessage,
			excludeEmptyString: true,
		}),
	}),

	clientLogo: Yup.string().matches(clientLogo.regex, { message: clientLogo.errorMessage, excludeEmptyString: true }),
};

export const combineSchemaObjs = schemas => {
	let newObject = {};
	schemas.forEach(item => {
		const newObjectArr = Object.keys(newObject);
		const itemArr = Object.keys(item);

		const notUnique = newObjectArr.some(property => itemArr.includes(property));
		if (notUnique) {
			console.warn(notUnique, newObjectArr, item);
			return item;
		}
		newObject = Object.assign(newObject, item);
	});
	return newObject;
};

export default webdemoValidationSchema;
